<template>
  <div>
        <text-input :label="label" :name="name" :error="phpError" v-model="utm.value" ref="textInputRef" @input-blur="handleBlur" />
  </div>
</template>

<script>
import TextInput from './Inputs/TextInput.vue';
import { EventBus } from '../event-bus.js';

export default {
    name: "UtmInput",
    props: {
        name: { type: String, required: true },
        label: { type: String, required: true },
        event: { type: String, required:true },
        savedValue: { type: String, default: '', required: false },
        options: { type: Array, default: [], required: false },
        phpError: { type: String, default: '', required: false },
    },
    components: {
        TextInput,
    },
    data() {
        return {
            utm: {
                value: this.$props.savedValue,
            },
            possibilities: this.$props.options,
        };
    },
    methods: {
        handleBlur() {
            if(this.utm.value.trim() == '') {
                const element = document.getElementById(this.event + '_id');

                if(element.selectedIndex != 0) {
                    const text = this.event == 'type' ? element.options[element.selectedIndex].dataset.medium : element.options[element.selectedIndex].text;
                    this.utm.value = text;
                }
            }
        },
        assignValue(name, value) {
            if(this.utm.value != '' && ! this.possibilities.includes(this.utm.value)) {

                return;
            }

            if(Number(value) == 0) {

                return this.utm.value = '';
            }

            return this.utm.value = name;
        }
    },
    created() {
        EventBus.$on(this.event + '-list-changed', (list) => {
            const newPossibilities = list.filter(item => item.name !== "Select" && item.value !== 0).map(item => item.name);
            this.possibilities = this.possibilities.includes(this.utm.value) && ! newPossibilities.includes(this.utm.value) ? [ this.utm.value ] : [];
            this.possibilities = [...this.possibilities, ...newPossibilities];
        });

        EventBus.$on(this.event + '-changed', (name, value) => {
            this.assignValue(name, value);
        });

        EventBus.$on(this.event + '-added', (name, value) => {
            this.assignValue(name, value);
        });
    },
    beforeDestroy() {
        EventBus.$off(this.event + '-changed');
        EventBus.$off(this.event + '-added');
        EventBus.$off(this.event + '-list-changed');
    },
}
</script>
